import { useState } from "react";
import { SlotMachine } from "@/components/slot-machine";
import { PublicMobileVerification } from "@/components/gamepoint/PublicMobileVerification";

export default function PublicSlotMachine() {
  const [isVerified, setIsVerified] = useState(false);

  return (
    <div className="scrollbar-casino h-screen overflow-x-hidden overflow-y-auto overscroll-y-contain bg-gradient-to-b from-[#05030a] via-[#12081f] to-[#0a0612] px-4 py-10 pb-16">
      <div className="mx-auto w-full max-w-3xl space-y-8 pb-8">
        <div className="space-y-3 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-amber-400/80">
            Game Point
          </p>
          <h1 className="text-3xl font-extrabold tracking-tight text-white drop-shadow-sm md:text-4xl">
            Spin the Reels.{" "}
            <span className="bg-gradient-to-r from-amber-300 to-purple-400 bg-clip-text text-transparent">
              Win Big.
            </span>
          </h1>
          <p className="mx-auto max-w-xl text-sm text-purple-200/70 md:text-base">
            Verify your mobile number once, then pull the lever or hit SPIN for
            instant rewards. Triple 7️⃣ wins the jackpot.
          </p>
        </div>

        <PublicMobileVerification
          theme="casino"
          onVerifiedChange={setIsVerified}
        />

        {isVerified ? (
          <SlotMachine className="mx-auto w-full max-w-2xl" />
        ) : (
          <div className="mx-auto flex max-w-2xl flex-col items-center justify-center rounded-2xl border border-dashed border-amber-500/25 bg-black/20 px-6 py-16 text-center backdrop-blur-sm">
            <p className="mb-3 text-4xl">🎰</p>
            <p className="text-sm text-purple-200/60">
              Complete mobile verification above to unlock the slot machine.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
